export default class AbstractModalBaseController {
    constructor($scope, $injector, $uibModalInstance) {
        this.scope = $scope;
        this.injector = $injector;
        this.uibModalInstance = $uibModalInstance;

        this.rootScope = this.injector.get('$rootScope');
    }

    dismissModal() {
        this.uibModalInstance.dismiss();
    }

    close(data) {
        this.uibModalInstance.close(data);
    }
}

AbstractModalBaseController.$inject = [
    '$scope',
    '$injector',
    '$uibModalInstance'
]



// WEBPACK FOOTER //
// ./src/app/modules/core/abstracts/controllers/modal-base-controller.js